export default import.meta.ROLLUP_FILE_URL_E8wuXQ_AmxPT2QBGX_$9Vw;